<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <BreadCrumb 
          parentRouteName="BadgeCampaignList" 
          :extra-items="isReadOnly ? [
            {
              text: form.name.length > 13 ? form.name.slice(0, 13) + '...' : form.name
            }
          ] : isEdit ? [
            {
              text: form.name.length > 13 ? form.name.slice(0, 13) + '...' : form.name,
              to: 'BadgeCampaignView',
              params: $route.params.id
            },
            '編輯'
          ] : [
            '新增'
          ]" 
        />
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">
            {{ isEdit ? "編輯" : isReadOnly ? "查看" : "新增" }}
          </h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <section class="row mb-8">
          <div class="col-12 col-xl-8">
            <!-- 徽章活動名稱 Start-->
            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="徽章活動名稱"
              label-for="name"
            >
              <b-form-input
                id="name"
                class="mb-2 mr-sm-2 mb-sm-0"
                type="text"
                :readonly="isReadOnly"
                v-model="form.name"
                :state="v$.form.name.$error ? false : null"
              ></b-form-input>
              <b-form-invalid-feedback :state="!v$.form.name.$error"
                >此欄位為必填</b-form-invalid-feedback
              >
            </b-form-group>
            <!-- 徽章活動名稱 End-->

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="主圖"
              label-for="subtitle"
            >
              <div class="image-selector">
                <div class="image" v-if="imageFile || form.image_url">
                  <img
                    class="img-fluid"
                    :src="imageFile != null ? imageFile : form.image_url"
                  />
                  <button
                    class="btn btn-danger"
                    type="button"
                    v-if="!isReadOnly"
                    @click="imageFile = form.image_url = null"
                  >
                    <i class="fa fa-times m-0" />
                  </button>
                </div>
                <div class="selector" v-else>
                  <ImageSelectorWithoutCrop
                    @input="selectImage"
                    class="
                      border
                      h-100
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <template #trigger="{ openFileSelector }">
                      <button
                        class="btn s-trigger-btn"
                        @click="openFileSelector"
                      >
                        <i class="fa fa-plus"></i> 圖片
                      </button>
                    </template>
                  </ImageSelectorWithoutCrop>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="注意事項"
              label-for="memo"
            >
              <ckeditor
                :editor="editor"
                :config="editorConfig"
                v-model="form.memo"
                tag-name="textarea"
                :disabled="isReadOnly"
                class="form-control mb-2 mr-sm-2 mb-sm-0"
              ></ckeditor>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="開始時間設定"
              label-for="start_at"
            >
              <div class="row">
                <div class="col-12 col-xl-6">
                  <datepicker
                    placeholder="選擇日期"
                    v-model="start_at.date"
                    bootstrap-styling
                    format="yyyy-MM-dd"
                    :language="zh"
                    :disabledDates="disabledDates"
                    :disabled="isReadOnly"
                    :state="v$.start_at.date.$error ? false : null"
                  ></datepicker>
                </div>

                <div class="col-12 col-xl-6">
                  <vue-timepicker
                    placeholder="選擇時間"
                    format="HH:mm"
                    v-model="start_at.time"
                    :input-class="['form-control']"
                    :disabled="isReadOnly"
                    :state="v$.start_at.time.HH.$error || v$.start_at.time.mm.$error ? false : null"
                  ></vue-timepicker>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-xl-6">
                  <b-form-invalid-feedback :state="!v$.start_at.date.$error">
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
                <div class="col-12 col-xl-6">
                  <b-form-invalid-feedback 
                    :state="
                      !v$.start_at.time.HH.$error || 
                      !v$.start_at.time.mm.$error
                    "
                  >
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="結束時間設定"
              label-for="end_at"
            >
              <div class="row">
                <div class="col-12 col-xl-6">
                  <datepicker
                    placeholder="選擇日期"
                    v-model="end_at.date"
                    bootstrap-styling
                    format="yyyy-MM-dd"
                    :language="zh"
                    :disabledDates="disabledDates"
                    :disabled="isReadOnly"
                    :state="v$.end_at.date.$error ? false : null"
                  ></datepicker>
                  <b-form-invalid-feedback
                    :state="!v$.start_at.date.beforeEndAt.$invalid"
                  >
                    結束時間必須大於起始時間
                  </b-form-invalid-feedback>
                </div>

                <div class="col-12 col-xl-6">
                  <vue-timepicker
                    placeholder="選擇時間"
                    format="HH:mm"
                    v-model="end_at.time"
                    :input-class="['form-control']"
                    :disabled="isReadOnly"
                  ></vue-timepicker>
                </div>
              </div>

              <div class="row">
                <div class="col-12 col-xl-6">
                  <b-form-invalid-feedback :state="!v$.end_at.date.$error">
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
                <div class="col-12 col-xl-6">
                  <b-form-invalid-feedback 
                    :state="
                      !v$.end_at.time.HH.$error || 
                      !v$.end_at.time.mm.$error
                    "
                  >
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
              </div>
            </b-form-group>

            <b-form-group
              label-cols="12"
              label-cols-lg="2"
              label-size="sm"
              label="狀態"
              label-for="type"
            >
              <b-form-select
                id="status"
                class="mb-2 mr-sm-2 mb-sm-0"
                v-model="form.status"
                :options="statusOptions"
                :disabled="isReadOnly"
              ></b-form-select>
            </b-form-group>
          </div>
        </section>
      </b-overlay>

      <div class="d-flex justify-content-center">
        <b-button 
          class="mr-4" 
          variant="outline-danger"
          @click="goToList"
        >
          {{ isReadOnly ? "返回" : "取消" }}
        </b-button>
        <b-overlay
          :show="isSubmmiting"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
          v-if="!isReadOnly"
        >
          <b-button variant="success" @click="handleSubmit">
            {{ isEdit ? "確認修改" : "確認新增" }}
          </b-button>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import { zh } from "vuejs-datepicker/dist/locale";
import { mapState, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import badgeCampaignApi from "@/apis/badgeCampaign";
import orgNameMixin from "@/mixins/organizationName";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import ImageSelectorWithoutCrop from "@/components/ImageSelectorWithoutCrop"
import imageMixin from "@/mixins/uploadImage";
import { format, isBefore, set, subDays, getHours, getMinutes } from "date-fns";
import imageApi from "@/apis/image";
import BreadCrumb from "@/components/Dashboard/BreadCrumb";

export default {
  components: { Datepicker, VueTimepicker, ImageSelectorWithoutCrop, BreadCrumb },
  mixins: [orgNameMixin, imageMixin],
  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      form: {
        name: { required },
      },
      start_at: {
        date: {
          required,
          beforeEndAt: () => {
            if (!this.start_at.date || !this.end_at.date) {
              return true;
            }

            const startDate = set(new Date(this.start_at.date), {
              hours: this.start_at.time.HH,
              minutes: this.start_at.time.mm,
            });

            const endDate = set(new Date(this.end_at.date), {
              hours: this.end_at.time.HH,
              minutes: this.end_at.time.mm,
            });

            return isBefore(startDate, endDate);
          },
        },
        time: {
          HH: { required },
          mm: { required },
        },
      },
      end_at: {
        date: { required },
        time: {
          HH: { required },
          mm: { required },
        },
      },
    };
  },

  data() {
    return {
      isLoading: false,
      isSubmmiting: false,
      start_at: {
        date: new Date(),
        time: {
          HH: "00",
          mm: "00",
        },
      },
      end_at: {
        date: null,
        time: {
          HH: "23",
          mm: "59",
        },
      },
      disabledDates: { to: subDays(new Date(), 1) },
      form: {
        name: "",
        status: "draft",
        memo: "",
        start_at: undefined,
        end_at: undefined,
        image_url: null,
      },
      statusOptions: [
        { value: "published", text: "發布" },
        { value: "draft", text: "草稿" },
        { value: "closed", text: "關閉" },
      ],
      editor: ClassicEditor,
      editorConfig: {
        extraPlugins: [this.MyCustomUploadAdapterPlugin],
      },
      zh,
      imageFile: null,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters("route", ["routeQuery"]),
    badgeCampaignId() {
      return this.$route.params.id;
    },
    merchantId() {
      return this.$route.params.merchantId;
    },
    isCreate() {
        return this.$route.name === "BadgeCampaignCreate";
    },
    isEdit() {
      return this.$route.name === "BadgeCampaignEdit";
    },
    isReadOnly() {
      return this.$route.name === "BadgeCampaignView";
    },
  },
  mounted() {
    var needCheckedPermission = null;
    if (this.isCreate) {
      needCheckedPermission = consts.BADGE_CAMPAIGN_CREATE;
    }
    else if (this.isEdit) {
      needCheckedPermission = consts.BADGE_CAMPAIGN_MODIFY
    }
    else if (this.isReadOnly) {
      needCheckedPermission = consts.BADGE_CAMPAIGN_LIST_VIEW
    }
    
    if (!this.checkPermission([needCheckedPermission]) ) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.goToList();
        });
    } else if (!this.isCreate && !this.isEdit && !this.isReadOnly && !this.merchantId) {
      this.$swal
        .fire({
          type: "error",
          text: "未指定通路",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.goToList();
        });
    } else if (this.badgeCampaignId) {
      this.fetchBadgeCampaign();
    }
  },
  methods: {
    async fetchBadgeCampaign() {
      try {
        this.isLoading = true;
        const { data } = await badgeCampaignApi.getBadgeCampaign(this.badgeCampaignId);
        const {
          name,
          status,
          memo,
          start_at,
          end_at,
          image_url,
        } = data.data;

        if (start_at) {
          this.start_at = {
            date: new Date(start_at),
            time: {
              HH: String(getHours(new Date(start_at))).padStart(2, "0"),
              mm: String(getMinutes(new Date(start_at))).padStart(2, "0"),
            },
          };
        }
        if (end_at) {
          this.end_at = {
            date: new Date(end_at),
            time: {
              HH: String(getHours(new Date(end_at))).padStart(2, "0"),
              mm: String(getMinutes(new Date(end_at))).padStart(2, "0"),
            },
          };
        }
        this.form = {
          name,
          status,
          memo,
          start_at,
          end_at,
          image_url,
        };
      } catch (error) {
        console.log("");
      }
      this.isLoading = false;
    },

    async handleSubmit() {
      const result = await this.v$.$validate();
      if (!result) return;

      this.formatDatetime("start_at");
      this.formatDatetime("end_at");

      try {
        this.isSubmmiting = true;

        if (this.imageFile) {
          const imageUrl = await this.uploadByBase64(this.imageFile);
          if (!imageUrl) {
            return;
          }
          this.form.image_url = imageUrl;
        }

        if (this.isEdit) {
          this.handleUpdate();
        } else {
          this.handleCreate();
        }
      } catch (error) {
        const { status, data } = error.response;
        if (status && status === 422 && data.message) {
          const html = Object.values(data.message)
            .map((m) => m[0])
            .join("<br/>");
          this.$swal.fire({
            type: "error",
            html,
          });
        }
      } finally {
        this.isSubmmiting = false;
      }
    },

    formatDatetime(key) {
      if (!this[key].date || !this[key].time.HH || !this[key].time.mm) return;

      this.form[key] = format(
        set(new Date(this[key].date), {
          hours: Number(this[key].time.HH),
          minutes: Number(this[key].time.mm),
          seconds: 0,
        }),
        "yyyy-MM-dd HH:mm:ss"
      );
    },
    
    async handleUpdate() {
      await badgeCampaignApi.updateBadgeCampaign(
        this.badgeCampaignId,
        this.form
      );
      this.showSuccessPopup();
    },

    async handleCreate() {
      await badgeCampaignApi.createBadgeCampaign(
        this.merchantId,
        this.form
      );
      this.showSuccessPopup();
    },

    goToList() {
      this.$router.push({ name: "BadgeCampaignList", query: this.routeQuery });
    },

    showSuccessPopup() {
      this.$swal
        .fire({
          type: "success",
          title: this.isEdit ? "修改成功" : "新增成功",
          confirmButtonText: "確定",
        })
        .then(() => {
          this.goToList();
        });
    },

    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },

    omitNullDate(form) {
      const result = { ...form };

      if (!result.start_at) {
        delete result.start_at;
      }
      if (!result.end_at) {
        delete result.end_at;
      }

      return result;
    },
    selectImage(image) {
      this.imageFile = image;
    },

    async MyCustomUploadAdapterPlugin(editor) {
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
        return {
          upload: () => {
            return new Promise((resolve, reject) => {
              loader.file.then((file) => {
                // 呼叫圖片上傳 API
                imageApi.upload(file)
                  .then((response) => {
                    console.log(response);
                    // 確認 API 回傳的結構，並傳遞正確的圖片 URL
                    const imageUrl = response.data.data.image.url; // 假設後端返回 { url: '圖片的完整URL' }
                    resolve({ default: imageUrl });
                  })
                  .catch((error) => {
                    console.error('圖片上傳失敗', error);
                    reject(error);
                  });
              });
            });
          },
        };
      };
    }

  },
};
</script>

<style lang="scss">
.ck-editor__editable_inline {
  min-height: 10rem;
}

.image-selector {
  .image {
    position: relative;
    width: 30%;
    button {
      position: absolute;
      top: -0.5rem;
      right: -0.5rem;
    }
  }
  .selector {
    width: 30%;
  }
}
</style>